/**
 * Toggles a boolean value, switching to the opposite of the passed parameter.
 */
export const toggle = (oldValue) => !oldValue;
//# sourceMappingURL=toggle.js.map